export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  permissions: string[];
  avatar?: string;
  createdAt: string;
  updatedAt: string;
}

export enum Permission {
  // Vendor permissions
  VIEW_VENDORS = 'vendors.view',
  CREATE_VENDORS = 'vendors.create',
  EDIT_VENDORS = 'vendors.edit',
  DELETE_VENDORS = 'vendors.delete',

  // Category permissions
  VIEW_CATEGORIES = 'categories.view',
  MANAGE_CATEGORIES = 'categories.manage',

  // User management
  MANAGE_USERS = 'users.manage',
  VIEW_CUSTOMERS = 'customers.view',
  MANAGE_PRODUCTS = 'products.manage',
  MANAGE_GOVERNANCE = 'governance.manage',
  VIEW_SALES_ORDERS = 'sales_orders.view',
  MANAGE_SALES_ORDERS = 'sales_orders.manage',
  MANAGE_CLAIMS = 'claims.manage',
  MANAGE_PURCHASE_ORDERS = 'purchase_orders.manage',
  VIEW_OCC = 'occ.view',
  MANAGE_SHIPPING = 'shipping.manage',
  MANAGE_RECEIPTS = 'receipts.manage',
  VIEW_FINANCE = 'finance.view',
  MANAGE_PAYMENTS = 'payments.manage',
  VIEW_REPORTS = 'reports.view',
}

export enum Role {
  ADMIN = 'admin',
  MANAGER = 'manager',
  STAFF = 'staff',
  VIEWER = 'viewer',
}
